import React from 'react'
import "./About.css"
function About() {
  return (
    <section className="NewAbout-Section-1">
  <div className="container">
    <div className="NewAbout_Section-Con">
      <div className="row">
        <div className="col-md-6">
          <div className="NewAboutUS-Image-Main-con">
            <div className="row">
              <div className="col-md-6">
                <div className="NewAboutUS-Image-con">
                  <img src="https://cdn0.weddingwire.com/vendor/074539/3_2/960/jpg/the-gold-ballroom-wedding_51_935470-166024712965961.jpeg" />
                </div>
              </div>
              <div className="col-md-6 displaynone">
                <div className="NewAboutUS-Image-Second-con">
                  <div className="NewAboutUS-Image-Second">
                    <img src="https://media.insider.in/image/upload/c_crop,g_custom/v1519627962/vltlogy23k1iid9pjffx.jpg" />
                  </div>
                </div>
              </div>
              <div className="col-md-6 displaynone">
                <div className="NewAboutUS-Image-Third-con">
                  <div className="NewAboutUS-Image-Third">
                    <img src="https://content.jdmagicbox.com/comp/mumbai/v3/022pxx22.xx22.180427015527.t4v3/catalogue/brahma-events-vartak-nagar-thane-west-thane-photographers-rghrwsucjk.jpg" />
                  </div>
                </div>
              </div>
              <div className="col-md-6 displaynone">
                <div className="NewAboutUS-Image-Forth-con">
                  <img src="https://www.lavanyamotel.com/img/restaurant/banquet-hall-3.jpg" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="NewAbout-Section-con-details-Info">
            <div className="NewAbout-Section-con-details-con">
              <div className="NewAbout-Section-con-details-Info-con">
                <h2 className="NewAboutUs-tagLlines paddingtopr">About Us</h2>
                <h3 className="textcent">
                  {" "}
                  Welcome to Savita Banquets
                </h3>
                <p style={{ textAlign: "justify" }}>
                  {" "}
                 Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus earum at possimus libero, nam numquam quae nobis explicabo reprehenderit non, dolore, obcaecati totam labore autem ducimus! Tempora perspiciatis, praesentium iure nihil consectetur deleniti animi, ipsam placeat expedita eligendi quis obcaecati, labore eum at sit eaque.
                </p>
                <p style={{ textAlign: "justify" }}>
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magni, cumque et? Repudiandae voluptate beatae, soluta eos doloribus distinctio at, nesciunt modi tenetur obcaecati, corrupti aspernatur voluptas officiis provident adipisci fugit illum repellendus iste explicabo pariatur magnam reprehenderit maxime quaerat? Quibusdam voluptatum modi maxime recusandae doloremque praesentium nam commodi est exercitationem?
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magni, cumque et? Repudiandae voluptate beatae, soluta eos doloribus distinctio at, nesciunt modi tenetur obcaecati, corrupti aspernatur voluptas officiis provident adipisci fugit illum repellendus iste explicabo pariatur magnam reprehenderit maxime quaerat? Quibusdam voluptatum modi maxime recusandae doloremque praesentium nam commodi est exercitationem?
                </p>
                <div className="NewAbout-Section-con-details-btn">
                  <button>Read More</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


  )
}

export default About
